import { HeroSection } from '@/components/landing/HeroSection'
import { BenefitsSection } from '@/components/landing/BenefitsSection'
import { ModalitiesSection } from '@/components/landing/ModalitiesSection'
import { MapSection } from '@/components/landing/MapSection'
import { HowItWorksSection } from '@/components/landing/HowItWorksSection'
import { BlogSection } from '@/components/landing/BlogSection'
import { FinalCTASection } from '@/components/landing/FinalCTASection'

const Index = () => {
  return (
    <>
      <HeroSection />
      <BenefitsSection />
      <ModalitiesSection />
      <MapSection />
      <HowItWorksSection />
      <BlogSection />
      <FinalCTASection />
    </>
  )
}

export default Index
